import { axiosPatientInstance } from "config";
import { SearchPatientsElement } from "modules/duplicate-patients/types";
import { useInfiniteQuery } from "react-query";
import { PaginationPayload, PaginationResponse, PatientFilter } from "types";

type SearchPatientsResponse = PaginationResponse<SearchPatientsElement>;
type UseSearchPatientsProps = PatientFilter & PaginationPayload;

function useSearchDuplicatePatients(props: UseSearchPatientsProps) {
  const { sort, descending, page = 1, size = 10, ...filters } = props;
  const validFilters = Object.entries(filters).reduce((curr, [k, v]) => {
    if (v) {
      return { ...curr, [k]: v };
    }
    return curr;
  }, {});

  return useInfiniteQuery(
    ["searchDuplicateEncounters", props],
    ({ pageParam = page }) =>
      axiosPatientInstance.get<SearchPatientsResponse>(
        `v1/duplicate-patients/search`,
        {
          params: {
            page: pageParam,
            pageSize: size,
            sortDesc: descending || false,
            orderBy: sort,
            ...validFilters,
          },
        }
      ),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.data.currentPage < lastPage.data.totalPages) {
          return lastPage.data.currentPage + 1;
        }
        return undefined;
      },
      getPreviousPageParam: (firstPage) => {
        if (firstPage.data.currentPage > 1) {
          return firstPage.data.currentPage - 1;
        }
        return undefined;
      },
    }
  );
}
export { useSearchDuplicatePatients };
export type { PatientFilter, UseSearchPatientsProps };
